import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { LoginFooter } from "../common/LoginFooter";
import configureStore from "../store";

const store = configureStore();
const $ = window.$

const Footer = (props) => {

    return (
        <LoginFooter {...props} />
    )
}

ReactDOM.render(
    <Provider store={store}>
        <Footer />
    </Provider>,
    document.getElementById("react-app-login-footer")
);

console.log("react app property login footer start");
